var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowOutward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Outward 20dp 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.35 6.05L4.01667 12.3833C3.89444 12.5056 3.75556 12.5639 3.6 12.5583C3.44444 12.5528 3.30556 12.4889 3.18333 12.3667C3.06111 12.2444 3 12.1028 3 11.9417C3 11.7806 3.06111 11.6389 3.18333 11.5167L9.5 5.2H4.15C3.98 5.2 3.8375 5.14283 3.7225 5.0285C3.6075 4.91417 3.55 4.7725 3.55 4.6035C3.55 4.4345 3.6075 4.29167 3.7225 4.175C3.8375 4.05833 3.98 4 4.15 4H10.95C11.12 4 11.2625 4.0575 11.3775 4.1725C11.4925 4.2875 11.55 4.43 11.55 4.6V11.4C11.55 11.57 11.4928 11.7125 11.3785 11.8275C11.2642 11.9425 11.1225 12 10.9535 12C10.7845 12 10.6417 11.9425 10.525 11.8275C10.4083 11.7125 10.35 11.57 10.35 11.4V6.05Z",
    fill: "#009DE2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOutward);
export default __webpack_public_path__ + "static/media/arrow-outward.221b43bc082719787c942ed54cd99bdc.svg";
export { ForwardRef as ReactComponent };